import GooglePlacesLookup from './components/GooglePlacesLookup';

export default angular.module('edge.platform.widgets.googleplaceslookup', [])
    .component('gwGooglePlacesLookup', GooglePlacesLookup);
